import Buttons from './Buttons'

export default Buttons



// WEBPACK FOOTER //
// ./src/components/Buttons/index.js